import React, { useEffect, useState, useContext } from 'react'
import { Box, Text } from "grommet"
import UserContext from '../../context/UserContext'
import Spinner from './Spinner'
import Warn from './Warn'
import { getLocalDateTimeWithTimeZoneFromEpochTime } from '../../utils/localdatetime'
import axios from 'axios'
import AgDataTable from '../common/AgDataTable'


export const AppDataAvailabilityHistory = ({ url }) => {

    const token = useContext(UserContext)
    const [loadingAPI, setLoadingAPI] = useState(true)
    const [urlResponse, setUrlResponse] = useState({})
    const [isError, setIsError] = useState("")

    useEffect(() => {
        //console.log('apiResult', url)
        const fetchAPI = async (url) => {
            setUrlResponse({})
            setLoadingAPI(true)
            console.log("Running API", url)
            try {
                const response = await axios(
                    url,
                )
                setUrlResponse(response)
                setLoadingAPI(false)
            } catch (error) {
                setUrlResponse(error.response)
                setIsError(error.message)
                setLoadingAPI(false)
            }
        }
        fetchAPI(url)
    }, [url])

    const tab_col = [
        {
            field: "ts",
            headerName: "Date",
            minWidth: 250,
            suppressSizeToFit: true,
        },
        {
            field: "state",
            headerName: "State",
            minWidth: 150,
            suppressSizeToFit: true,
        },
        {
            field: "server",
            headerName: "Server",
            minWidth: 150,
            suppressSizeToFit: true,
        },
        {
            field: "session_id",
            headerName: "Session ID",
            minWidth: 150,
            suppressSizeToFit: true,
        },
        {
            field: "info",
            headerName: "Info",
            minWidth: 200,
            suppressSizeToFit: true,
            cellStyle: function (params) {
                if (!params.value) {
                    return { color: 'black', backgroundColor: 'white' };
                } else if (params.value === 'up') {
                    return { color: 'black', backgroundColor: 'white' };
                } else if (params.value.toLowerCase() === 'exchange scheduled down') {
                    return { color: 'white', backgroundColor: '#A6A6A6' };
                } else {
                    return { color: 'white', backgroundColor: '#B4130B' };
                }
            }
        },
    ]

    const [tab_data, settab_data] = useState([])

    useEffect(() => {
        let tab_data_temp = []
        let rowNumber = 0
        console.log(urlResponse)
        if (urlResponse && Object.keys(urlResponse).length > 0 && urlResponse.status === 200 && urlResponse.data && urlResponse.data.length > 0) {
            tab_data_temp = urlResponse.data.reduce((rowData, row) => {
                rowNumber += 1
                rowData.push({
                    'uniqueId': rowNumber,
                    'info': row.info,
                    'server': row.server,
                    'session_id': row.session_id,
                    'session_type': row.session_type,
                    'status': row.status,
                    'state': row.state,
                    'ts': row.ts ? getLocalDateTimeWithTimeZoneFromEpochTime(token.timezone, row.ts) : '',
                })
                return rowData
            }, [])
            settab_data(tab_data_temp)
        }
    }, [urlResponse, token.timezone])

    return (
        <Box margin="xsmall" pad="xsmall">
            <Text size="small">Data From Availability - {url}</Text>
            {loadingAPI && <Spinner />}
            {!loadingAPI && tab_data.length === 0 && isError && <Box pad="small"><Warn warning={isError} /></Box>}
            {tab_data.length > 0 &&
                <AgDataTable
                    tab_col={tab_col}
                    tab_data={tab_data}
                    tableName="AppDataAvailabilityHistory"
                />
            }
        </Box>
    )
}

export default AppDataAvailabilityHistory